/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { InRecycleBinDocumentList } from '../../models/in-recycle-bin-document-list';

export interface VaultGetInRecycleBinDocumentList$Params {

/**
 * GUID of the vault
 */
  vaultId: string;

/**
 * Requested document count. Value must be less than or equal to 255
 */
  count?: number;
}

export function vaultGetInRecycleBinDocumentList(http: HttpClient, rootUrl: string, params: VaultGetInRecycleBinDocumentList$Params, context?: HttpContext): Observable<StrictHttpResponse<InRecycleBinDocumentList>> {
  const rb = new RequestBuilder(rootUrl, vaultGetInRecycleBinDocumentList.PATH, 'get');
  if (params) {
    rb.path('vaultId', params.vaultId, {});
    rb.query('count', params.count, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<InRecycleBinDocumentList>;
    })
  );
}

vaultGetInRecycleBinDocumentList.PATH = '/vault/{vaultId}/in-recycle-bin-document/list';
